/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_PlateInputs */

const en_case_field_plate = /** @type {(inputs: Case_Field_PlateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plate`)
};

const pt_br2_case_field_plate = /** @type {(inputs: Case_Field_PlateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placa`)
};

/**
* | output |
* | --- |
* | "Plate" |
*
* @param {Case_Field_PlateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_plate = /** @type {((inputs?: Case_Field_PlateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_PlateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_plate(inputs)
	return pt_br2_case_field_plate(inputs)
});